import React from 'react';
import './AppsWrapper.scss';

interface SGAppsWrapperProps {
    darken: boolean;
    children?: React.ReactNode;
}

export const AppsWrapper = (props: SGAppsWrapperProps) => {
    return (
        <div className={`apps-wrapper__container ${props.darken ? 'apps-wrapper__container--darken' : ''}`}>
            {props.children}
        </div>
    );
} 
